import { render } from "./StavoviZaposlenih.vue?vue&type=template&id=6c56874c&scoped=true&lang=html"
import script from "./StavoviZaposlenih.vue?vue&type=script&lang=js"
export * from "./StavoviZaposlenih.vue?vue&type=script&lang=js"

import "./StavoviZaposlenih.vue?vue&type=style&index=0&id=6c56874c&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-6c56874c"

export default script